import type { ChatContainerFieldsFragment } from 'js/chat/fragments/ChatContainerFields.fragment.generated'

export type ChatContainerView = {
    title: string
    isSingle: boolean
}

export default function getChatContainer(
    container: ChatContainerFieldsFragment | null | undefined,
): ChatContainerView | null {
    if (!container) {
        return null
    }

    const { group } = container
    if (group) {
        return { title: group.name ?? '', isSingle: true }
    }

    const users = (container.users ?? []).filter((user) => user !== null)

    return {
        title: users.map((user) => user.name).join(', '),
        isSingle: users.length === 1,
    }
}
